import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import {
  GET_ALERT_STATUS_CHART,
  GET_ALERTS_ANOMALIES_CHART,
  GET_ALERTS_YIELD_CHART,
  GET_CUSTOMER_CLUSTER_CHART,
  GET_CUSTOMER_DATA,
  GET_FIGURE_DATA,
  GET_NOISSUE_L1_CHART,
  GET_SEGMENT_LIST_DATA,
  GET_STR_CHART,
  getAlertsAnomaliesChartFail,
  getAlertsAnomaliesChartSuccess,
  getAlertStatusChartFail,
  getAlertStatusChartSuccess,
  getAlertsYieldChartFail,
  getAlertsYieldChartSuccess,
  getCustomerClusterChartFail,
  getCustomerClusterChartSuccess,
  getCustomerDataFail,
  getCustomerDataSuccess,
  getFigureDataFail,
  getFigureDataSuccess,
  getNoIssueL1ChartFail,
  getNoIssueL1ChartSuccess,
  getSegmentListDataFail,
  getSegmentListDataSuccess,
  getStrChartFail,
  getStrChartSuccess
} from '../../redux/actions/tm/dashboard';

import {
  getAlertsAnomaliesChartData,
  getAlertStatusChartData,
  getAlertYieldChartData,
  getCustomerClusterChartData,
  getCustomerViewData,
  getFigureData,
  getNoIssueL1ChartData,
  getSegmentListData,
  getStrChartData
} from '../../services/tm/dashboard';

// Figures data

function* getFigureDataWorker(payload) {
  try {
    const { currentPeriod, previousPeriod } = payload;
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const currentPeriodResponse = yield call(getFigureData, currentPeriod);
    const previousPeriodResponse = yield call(getFigureData, previousPeriod);
    const responseData = {
      current: currentPeriodResponse,
      previous: previousPeriodResponse
    };

    yield put(getFigureDataSuccess(responseData));
  } catch (error) {
    yield put(getFigureDataFail({ error: 'Failed to retrieve figure data.' }));
  }
}

export function* watchGetFigureData() {
  yield takeEvery(GET_FIGURE_DATA, function* ({ payload }) {
    yield fork(getFigureDataWorker, payload);
  });
}

// Alerts and Anomalies

function* getAlertsAnomaliesDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getAlertsAnomaliesChartData, payload);
    yield put(getAlertsAnomaliesChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getAlertsAnomaliesChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetAlertsAndHits() {
  yield takeEvery(GET_ALERTS_ANOMALIES_CHART, function* ({ payload }) {
    yield fork(getAlertsAnomaliesDataWorker, payload);
  });
}

// Alerts Yield

function* getAlertsYieldDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getAlertYieldChartData, payload);
    yield put(getAlertsYieldChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getAlertsYieldChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetAlertsYield() {
  yield takeEvery(GET_ALERTS_YIELD_CHART, function* ({ payload }) {
    yield fork(getAlertsYieldDataWorker, payload);
  });
}

// No Issue and L1

function* getNoissueL1DataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNoIssueL1ChartData, payload);
    yield put(getNoIssueL1ChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getNoIssueL1ChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetNoIssueL1() {
  yield takeEvery(GET_NOISSUE_L1_CHART, function* ({ payload }) {
    yield fork(getNoissueL1DataWorker, payload);
  });
}

// STR

function* getStrDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getStrChartData, payload);
    yield put(getStrChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getStrChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchGetStr() {
  yield takeEvery(GET_STR_CHART, function* ({ payload }) {
    yield fork(getStrDataWorker, payload);
  });
}

// Alert Status Breakdown

function* getAlertStatusBreakdownDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getAlertStatusChartData, payload);
    yield put(getAlertStatusChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getAlertStatusChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchAlertStatusBreakdown() {
  yield takeEvery(GET_ALERT_STATUS_CHART, function* ({ payload }) {
    yield fork(getAlertStatusBreakdownDataWorker, payload);
  });
}

// Segments list

function* getSegmentListDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getSegmentListData, payload);
    yield put(getSegmentListDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getSegmentListDataFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchSegmentList() {
  yield takeEvery(GET_SEGMENT_LIST_DATA, function* ({ payload }) {
    yield fork(getSegmentListDataWorker, payload);
  });
}

// Customer View

function* getCustomerViewDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getCustomerViewData, payload);
    yield put(getCustomerDataSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getCustomerDataFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchCustomerView() {
  yield takeEvery(GET_CUSTOMER_DATA, function* ({ payload }) {
    yield fork(getCustomerViewDataWorker, payload);
  });
}

// Cluster Chart

function* getCustomerClusterChartDataWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getCustomerClusterChartData, payload);
    yield put(getCustomerClusterChartSuccess(response));

    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(getCustomerClusterChartFail({ error: 'Please try again' }));
    yield put(ga.fetchFailed({ error: '' }));
  }
}

export function* watchCustomerClusterChart() {
  yield takeEvery(GET_CUSTOMER_CLUSTER_CHART, function* ({ payload }) {
    yield fork(getCustomerClusterChartDataWorker, payload);
  });
}
